import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import findKey from 'lodash/findKey';
import { useSelector } from 'react-redux';
import { PageTitle, PageContent, Tab } from 'nallian-shared-ui/lib/components';
import { TABS } from './constants';
import AwaitCommunity from '../app/hoc/AwaitCommunity';
import { AwaitCommunityId } from '../selectors';
import CommunityMembersOverview from './members/components/CommunityMembersOverview';
import RelationsOverview from '../../mgmt/communities/components/relations/RelationsOverview';
import JoinRequestsOverview from '../../mgmt/communities/components/joinRequests/JoinRequestsOverview';

const TAB_INDEX_MAPPING = {
  [TABS.MEMBERS]: 0,
  [TABS.JOIN_REQUESTS]: 1,
  [TABS.RELATIONS]: 2,
};

const CommunityDetails = () => {
  const { t } = useTranslation();
  const { tab } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!tab) navigate(`/community/${TABS.MEMBERS}`);
  }, [tab, navigate]);

  const communityId = useSelector(AwaitCommunityId);

  return (
    <PageContent>
      <PageTitle flexed>{t('myCommunity')}</PageTitle>
      <Tab
        activeIndex={TAB_INDEX_MAPPING[tab]}
        onTabChange={(e, { activeIndex }) => {
          const activeTab = findKey(TAB_INDEX_MAPPING, index => index === activeIndex);
          if (activeTab) navigate(`/community/${activeTab}`);
        }}
        panes={[
          {
            menuItem: t('members'),
            render: () => (
              <Tab.Pane>
                <CommunityMembersOverview communityId={communityId} isCommunityView />
              </Tab.Pane>
            ),
          },
          {
            menuItem: t('joinRequests'),
            render: () => (
              <Tab.Pane>
                <JoinRequestsOverview
                  isCommunityView
                  communityId={communityId}
                  rootUrl={`/community/${TABS.JOIN_REQUESTS}`}
                />
              </Tab.Pane>
            ),
          },
          {
            menuItem: t('relations'),
            render: () => (
              <Tab.Pane>
                <RelationsOverview
                  communityId={communityId}
                  rootUrl={`/community/${TABS.RELATIONS}`}
                />
              </Tab.Pane>
            ),
          },
        ]}
      />
    </PageContent>
  );
};

export default AwaitCommunity(CommunityDetails);
